import { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";

const ImagePreviewModal = ({ src, anchorRef, onClose, onRemove }) => {
  const popRef = useRef(null);
  const [pos, setPos] = useState(null);

  // Compute position once anchor is available
  useEffect(() => {
    if (!anchorRef?.current) return;
    const rect = anchorRef.current.getBoundingClientRect();
    setPos({
      top:  rect.top + rect.height / 2,
      left: rect.right + 8,
    });
  }, [anchorRef]);

  // Close on outside click
  useEffect(() => {
    const handler = (e) => {
      if (
        popRef.current && !popRef.current.contains(e.target) &&
        anchorRef?.current && !anchorRef.current.contains(e.target)
      ) onClose();
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [onClose, anchorRef]);

  // Close on Escape
  useEffect(() => {
    const handler = (e) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", handler);
    return () => document.removeEventListener("keydown", handler);
  }, [onClose]);

  if (!pos) return null;

  return ReactDOM.createPortal(
    <div
      ref={popRef}
      style={{
        position:      "fixed",
        top:           pos.top,
        left:          pos.left,
        transform:     "translateY(-50%)",
        zIndex:        99999,
        background:    "#fff",
        borderRadius:  10,
        boxShadow:     "0 4px 24px rgba(0,0,0,0.2)",
        padding:       12,
        width:         200,
        display:       "flex",
        flexDirection: "column",
        alignItems:    "center",
        gap:           10,
      }}
    >
      {/* Arrow pointing left toward avatar */}
      <div style={{
        position:     "absolute",
        left:         -9,
        top:          "50%",
        transform:    "translateY(-50%)",
        width:        0,
        height:       0,
        borderTop:    "9px solid transparent",
        borderBottom: "9px solid transparent",
        borderRight:  "9px solid #fff",
        filter:       "drop-shadow(-2px 0 2px rgba(0,0,0,0.1))",
      }} />

      {src ? (
        <img
          src={src}
          alt="Patient"
          style={{
            width:        "100%",
            height:       170,
            objectFit:    "cover",
            borderRadius: 7,
            display:      "block",
          }}
        />
      ) : (
        <div style={{
          width:          "100%",
          height:         130,
          display:        "flex",
          flexDirection:  "column",
          alignItems:     "center",
          justifyContent: "center",
          color:          "#9e8f82",
          fontSize:       13,
          gap:            8,
          background:     "#f4efe8",
          borderRadius:   7,
        }}>
          <span style={{ fontSize: 34 }}>🖼️</span>
          No image to show
        </div>
      )}

      {src && onRemove && (
        <button
          type="button"
          onClick={() => {
            onRemove();
          }}
          style={{
            padding:      "6px 0",
            borderRadius: 6,
            border:       "1px solid #e76f51",
            background:   "#fff",
            color:        "#e76f51",
            fontWeight:   600,
            fontSize:     13,
            cursor:       "pointer",
            width:        "100%",
            display:      "flex",
            alignItems:   "center",
            justifyContent: "center",
            gap:          "6px"
          }}
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="3 6 5 6 21 6"/>
            <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/>
            <path d="M10 11v6M14 11v6"/>
            <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/>
          </svg>
          Remove
        </button>
      )}

      <button
        type="button"
        onClick={onClose}
        style={{
          padding:      "6px 0",
          borderRadius: 6,
          border:       "none",
          background:   "#2a9d8f",
          color:        "#fff",
          fontWeight:   600,
          fontSize:     13,
          cursor:       "pointer",
          width:        "100%",
        }}
      >
        Close
      </button>
    </div>,
    document.body
  );
};

export default ImagePreviewModal;